import { styled } from '@mui/system'
import { Link, Paper, Typography } from '@mui/material'

export const TypographyH2 = styled(Typography)({
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '20px',
  lineHeight: '32px',
  letterSpacing: '0.15px',
  color: '#000000',
  padding: '16px',
  boxShadow: 'inset 0px -1px 0px rgba(0, 0, 0, 0.12)',
})

export const TypographyH6 = styled(Typography)({
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '19x',
  letterSpacing: '0.4px',
  padding: '14px 16px',
})

export const LinkToDetail = styled(Link)({
  color: '#3F51B5',
  cursor: 'pointer',
})

export const FavoriteListPaper = styled(Paper)({
  background: '#FFFFFF',
  marginTop: '40px',
  marginBottom: '212px',
})

export const ViewContactOrderListPaper = styled(Paper)({
  background: '#FFFFFF',
  marginTop: '40px',
})
